export const en = {
    "k_c78ca785": "Failed to open editor: Missing application ID or page ID parameter",
    "k_12477066": "Failed to open editor: page does not exist",
    "k_304ff7f9": "Create offline tasks",
    "k_9c36aae0": "Delete offline tasks",
    "k_10143f5f": "Create offline configurations",
    "k_b1bb5121": "Update offline configuration",
    "k_1a099cc4": "Delete offline configuration",
    "k_8c27b8e5": "Debugging offline configuration"
};
